module.exports = __webpack_public_path__ + "img/h5-bg.f7ed0bae.png";